import React, { PureComponent } from 'react';

import UsersListBulkActions from './UsersListBulkActions';
import UsersListColumnsManager from './UsersListColumnsManager';

import './UsersListActions.scss';

class UsersListActions extends PureComponent {
  render() {
    return (
      <div className="users__list__actions">
        <UsersListBulkActions />
        <UsersListColumnsManager />
      </div>
    );
  }
}

export default UsersListActions;
